import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { PasswordField, passwordValid } from "@/components/PasswordField";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const reset = () => { setCur(""); setPw(""); setPw2(""); };

  const submit = async () => {
    if (!passwordValid(pw)) return toast.error("Den nye adgangskode opfylder ikke kravene");
    if (pw !== pw2) return toast.error("De to adgangskoder er ikke ens");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Adgangskoden er ændret", { description: "Du er logget ud på alle andre enheder." });
      reset(); onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
      <DialogContent className="rounded-2xl sm:max-w-[460px]" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">Skift adgangskode</DialogTitle>
          <DialogDescription className="text-sm text-stone-500">Dine andre enheder bliver logget ud, når du skifter.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-1">
          <div className="space-y-1.5">
            <Label className="text-sm font-medium">Nuværende adgangskode</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} autoComplete="current-password" className="h-11 rounded-xl bg-white" data-testid="chpw-current" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium">Ny adgangskode</Label>
            <PasswordField value={pw} onChange={setPw} testid="chpw-new" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium">Gentag ny adgangskode</Label>
            <PasswordField value={pw2} onChange={setPw2} placeholder="Gentag adgangskode" testid="chpw-new2" showRules={false} />
          </div>
        </div>
        <DialogFooter className="mt-2">
          <Button variant="outline" className="rounded-xl border-[#EBE8E3]" onClick={() => onOpenChange(false)}>Annullér</Button>
          <Button className="rounded-xl font-medium bg-[#A83232] hover:bg-[#8f2a2a]" onClick={submit} disabled={busy || !cur || !pw} data-testid="chpw-submit">{busy ? "Gemmer…" : "Skift adgangskode"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
